import React from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";

const GlobalPopup = ({ show, message, onClose }) => {
  return (
    <Modal isOpen={show} centered backdrop="static">
      <ModalHeader>New Booking Received</ModalHeader>
      <ModalBody className="text-center">
        <p>{message}</p>
        <Button color="primary" onClick={onClose}>
          OK
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default GlobalPopup;
